<!-- Loading State -->
<div class="drawer-overlay" *ngIf="loading">
  <div class="drawer-container">
    <div class="drawer-content">
      <div class="loading-spinner">Loading...</div>
    </div>
  </div>
</div>

<!-- Error State -->
<div class="drawer-overlay" *ngIf="error">
  <div class="drawer-container">
    <div class="drawer-header">
      <h2 class="drawer-title">Error</h2>
      <button class="close-btn" (click)="closeDrawer()">
        <img src="assets/img/svg/close-x-lg.svg" alt="close">
      </button>
    </div>
    <div class="drawer-content">
      <div class="error-message">{{ error }}</div>
    </div>
  </div>
</div>

<!-- Main Content -->
<div class="drawer-overlay" *ngIf="!loading && !error" (click)="closeDrawer()">
  <div class="drawer-container" (click)="$event.stopPropagation()">
    <!-- Header -->
    <div class="drawer-header">
      <h2 class="drawer-title">{{ rfqData?.rfqName}}</h2>
      <button class="close-btn" (click)="closeDrawer()">
        <img src="assets/img/svg/close-x-lg.svg" alt="close">
      </button>
    </div>

    <!-- Content -->
    <div class="drawer-content" *ngIf="rfqData">
      <!-- RFQ Number -->
      <div class="rfq-number">{{ rfqData.rfqSequenceId }}</div>

      <!-- Parts Section -->
      <div class="section">
        <h3 class="section-title">Parts</h3>
        <div class="parts-list accordion" id="partsAccordion">
          <div class="accordion-item" *ngFor="let part of rfqData.rfqPartList; let i = index">
            <div class="part-item">
              <div class="part-info">
                <div class="part-label">{{ part.partName }}</div>
                <div class="part-name">{{ part.partId }}</div>
              </div>
              <div class="part-actions">
                <span class="quantity-badge">
                  <img src="assets/img/svg/attachment.svg" alt="attachment">
                  ({{ part.files?.length || 0 }})
                </span>
                <button class="add-btn collapsed" [attr.data-bs-toggle]="'collapse'" [attr.data-bs-target]="'#collapse' + i"
                  aria-expanded="false" [attr.aria-controls]="'collapse' + i">
                </button>
              </div>
            </div>
            <div [id]="'collapse' + i" class="accordion-collapse collapse" [attr.aria-labelledby]="'heading' + i"
              data-bs-parent="#partsAccordion">
              <div class="accordion-body">
                <div class="part-item-list">
                  <strong>Quantity</strong>
                  <p>{{ part.qty1 }}</p>
                </div>
                <div class="part-item-list" *ngIf="part.material">
                  <strong>Material</strong>
                  <p>{{ part.material }}</p>
                </div>
                <div class="part-item-list" *ngIf="part.grade">
                  <strong>Grade</strong>
                  <p>{{ part.grade?part.grade : '-' }}</p>
                </div>
                <div class="part-item-list">
                  <strong>Finish</strong>
                  <p>{{ getFinishDisplay(part.finish) }}</p>
                </div>
                <div class="part-item-list" *ngIf="part.tolerance">
                  <strong>Tolerance</strong>
                  <p>{{ part.tolerance?part.tolerance : '-' }}</p>
                </div>
                <div class="part-item-list" *ngIf="part.notes">
                  <strong>Notes</strong>
                  <p>{{ part.notes?part.notes : '-' }}</p>
                </div>
                <div class="part-item-list" *ngIf="part.files?.length > 0">
                  <strong>Files</strong>
                  <p *ngFor="let file of part.files">
                    <a [href]="file.fileUrl" target="_blank">
                      <img src="assets/img/svg/attachment.svg" alt="attachment"> {{ file.fileName.includes('_S3_') ? file.fileName.split('_S3_').pop() : file.fileName }}
                    </a>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Overview Section -->
      <div class="section">
        <h3 class="section-title">Overview</h3>
        <hr class="section-divider">
      </div>

      <div class="section">
        <h3 class="section-title">Quotes Date</h3>
        <div class="cert-list">
          <div class="cert-item">{{ rfqData.quoteBy  | date: 'MM/dd/yyyy' }}</div>
        </div>
      </div>
      <div class="section">
        <h3 class="section-title">Delivery Date</h3>
        <div class="cert-list">
          <div class="cert-item" >{{ rfqData.deliverBy | date: 'MM/dd/yyyy' }}</div>
        </div>
      </div>
      <!-- Certifications -->
      <div class="section">
        <h3 class="section-title">Certifications & Qualifications</h3>
        <div class="cert-list">
          <ng-container *ngIf="rfqData.certificates?.length > 0; else noCerts">
            <div class="cert-item" *ngFor="let cert of rfqData.certificates">{{ cert }}</div>
          </ng-container>
          <ng-template #noCerts>
            <div class="cert-item">-</div>
          </ng-template>
        </div>
      </div>

      <!-- Inspections -->
      <div class="section">
        <h3 class="section-title">Inspections</h3>
        <div class="inspection-list">
          <ng-container *ngIf="rfqData.inspections?.length > 0; else noInspections">
            <div class="inspection-item" *ngFor="let inspection of rfqData.inspections">{{ inspection }}</div>
          </ng-container>
          <ng-template #noInspections>
            <div class="inspection-item">-</div>
          </ng-template>
        </div>
      </div>

      <!-- Shipping Address -->
      <div class="section overview-section" >
        <h3 class="section-title">Shipping Address</h3>
        <div class="address">
          <div>{{ rfqData.address1 }}</div>
          <div *ngIf="rfqData.address2">{{ rfqData.address2 }}</div>
          <div>{{ rfqData.city }}, {{ rfqData.state }} {{ rfqData.zip }}</div>
          <div>{{ rfqData.country }}</div>
        </div>
      </div>

      <!-- Preferred Payment Terms -->
      <div class="section overview-section">
        <h3 class="section-title">Preferred Payment Terms</h3>
        <div class="payment-terms">{{ rfqData.paymentTerms }}</div>
      </div>

      <!-- Communication -->
      <div class="section overview-section">
        <h3 class="section-title">Communication</h3>
        <div class="contact-info">
          <div class="contact-name">{{ rfqData.buyerName || 'N/A' }}</div>
          <div class="contact-email">{{ rfqData.buyerEmailAddress }}</div>
          <div class="contact-phone">{{ rfqData.buyerPhoneNumber || 'N/A' }}</div>
        </div>
      </div>
    </div>
  </div>
</div>